// Careers form add-ons:
//   1. Step 1 State / ZIP validation (the main validator in thl-careers.js predates these fields)
//   2. Live US phone formatting -> (480) 555-0123
//   3. Position-aware questions: front desk applicants are not asked stylist-only questions
// Listeners sit on document in the capture phase so they always run before the
// Next button's own handler, whichever script loaded first.
(function () {
  var form = document.getElementById('tc-form');
  if (!form) return;

  function fieldOf(name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el && el.closest('.tc-field');
  }
  function setErr(name, msg) {
    var f = fieldOf(name);
    if (!f) return;
    f.classList.toggle('err', !!msg);
    var m = f.querySelector('.tc-msg');
    if (m) m.textContent = msg || '';
  }
  function onStep1() {
    var p = form.querySelector('.tc-page.active');
    return !!p && p.getAttribute('data-step') === '1';
  }

  /* ---------- Step 1: State + ZIP ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#tc-next') : null;
    if (!btn || !onStep1()) return;

    var stateEl = form.querySelector('[name="state"]');
    var zipEl = form.querySelector('[name="zip"]');
    var phoneEl = form.querySelector('[name="phone"]');
    var bad = null;

    if (stateEl) {
      if (!(stateEl.value || '').trim()) { setErr('state', 'Please choose your state.'); bad = bad || 'state'; }
      else setErr('state', '');
    }
    if (zipEl) {
      var z = (zipEl.value || '').trim();
      if (!/^\d{5}(-\d{4})?$/.test(z)) {
        setErr('zip', z ? 'Please enter a valid 5-digit ZIP code.' : 'Please enter your ZIP code.');
        bad = bad || 'zip';
      } else setErr('zip', '');
    }
    if (phoneEl) {
      var pd = digitsOf(phoneEl.value);
      if (pd && pd.length !== 10) {
        setErr('phone', 'Please enter a 10-digit phone number.');
        bad = bad || 'phone';
      }
    }

    if (bad) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var el = form.querySelector('[name="' + bad + '"]');
      if (el && el.focus) el.focus({ preventScroll: true });
      var f = fieldOf(bad);
      if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  // ZIP: digits only, but allow the ZIP+4 hyphen.
  var zip = document.getElementById('tc-zip');
  if (zip) {
    zip.addEventListener('input', function () {
      var v = zip.value.replace(/[^0-9-]/g, '').slice(0, 10);
      if (v !== zip.value) zip.value = v;
    });
  }

  /* ---------- Phone: live (480) 555-0123 ---------- */

  function digitsOf(s) {
    var d = String(s || '').replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);   // leading US country code
    return d.slice(0, 10);
  }

  function pretty(d) {
    if (!d) return '';
    if (d.length < 4) return '(' + d;
    if (d.length < 7) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }

  function countDigits(s) { return (String(s).match(/\d/g) || []).length; }

  function formatPhone(el, e) {
    var before = el.value;
    var caret = el.selectionStart === null ? before.length : el.selectionStart;
    var digitsBefore = countDigits(before.slice(0, caret));

    // Backspacing over a separator should eat the digit in front of it, or nothing happens.
    var inputType = e && e.inputType;
    if (inputType === 'deleteContentBackward' && caret > 0 && !/\d/.test(before.charAt(caret - 1)) && digitsBefore > 0) {
      digitsBefore -= 1;
      var arr = digitsOf(before).split('');
      arr.splice(digitsBefore, 1);
      el.value = pretty(arr.join(''));
    } else {
      el.value = pretty(digitsOf(before));
    }

    // Put the caret back after the same number of digits.
    var pos = el.value.length, seen = 0;
    if (digitsBefore > 0) {
      for (var i = 0; i < el.value.length; i++) {
        if (/\d/.test(el.value.charAt(i))) {
          seen++;
          if (seen === digitsBefore) { pos = i + 1; break; }
        }
      }
    } else if (el.value) {
      pos = 1;   // just after the opening bracket
    }
    try { el.setSelectionRange(pos, pos); } catch (err) {}
  }

  [].forEach.call(form.querySelectorAll('input[type="tel"], #tc-phone'), function (el) {
    if (el._thlPhone) return;
    el._thlPhone = true;
    el.setAttribute('inputmode', 'tel');
    el.setAttribute('maxlength', '20');
    el.setAttribute('placeholder', '(480) 555-0123');
    el.addEventListener('input', function (e) { formatPhone(el, e); });
    el.addEventListener('blur', function () {
      var d = digitsOf(el.value);
      el.value = d.length === 10 ? pretty(d) : el.value;
      if (d.length === 10) setErr('phone', '');
    });
    if (el.value) el.value = pretty(digitsOf(el.value));   // tidy anything restored from a saved session
  });

  /* ---------- Position-aware questions ----------
     "Years behind the chair", "Do you have your own clientele?", "clients a
     month", the specialty checkboxes and the extension methods are stylist
     questions. A front desk applicant should not be asked them.

     The form and the Apps Script both require an answer to the first two, so
     hiding them alone would block the submission. They are hidden AND answered
     "N/A - front desk" through an option that only exists while front desk is
     selected. That keeps the tracker honest: a receptionist reads as not
     applicable rather than carrying a wrong answer like "Still in school".

     Everything cleared here is remembered, so switching position back and forth
     never silently loses what someone already typed. */

  var NA = 'N/A - front desk';
  var FRONT_DESK = 'Front Desk / Reception';

  var posEl = form.querySelector('[name="position"]');
  var yearsEl = form.querySelector('[name="years"]');
  var clientsEl = form.querySelector('[name="clientsPerMonth"]');
  var extEl = form.querySelector('[name="extensionMethods"]');
  var extWrap = document.getElementById('tc-ext-wrap');
  var prev = { years: '', clients: '', ext: '', specs: null };

  function specBoxes() { return form.querySelectorAll('input[name="specialties"]'); }

  // The N/A option is created only while front desk is selected and removed
  // again afterwards, so a stylist can never see or pick it - not even on an
  // old browser that ignores the hidden attribute on an option.
  function addNaOption(select) {
    if (!select) return null;
    var o = select.querySelector('option[data-na="1"]');
    if (!o) {
      o = document.createElement('option');
      o.value = NA;
      o.textContent = NA;
      o.setAttribute('data-na', '1');
      o.hidden = true;
      select.appendChild(o);
    }
    return o;
  }
  function dropNaOption(select) {
    if (!select) return;
    var o = select.querySelector('option[data-na="1"]');
    if (o) o.parentNode.removeChild(o);
  }

  function addNaRadio(name) {
    var any = form.querySelector('[name="' + name + '"]');
    var group = any && any.closest('.tc-chips');
    if (!group) return null;
    var r = group.querySelector('input[data-na="1"]');
    if (!r) {
      var lab = document.createElement('label');
      lab.setAttribute('data-na-label', '1');
      lab.style.display = 'none';
      r = document.createElement('input');
      r.type = 'radio';
      r.name = name;
      r.value = NA;
      r.setAttribute('data-na', '1');
      lab.appendChild(r);
      group.appendChild(lab);
    }
    return r;
  }
  function dropNaRadio(name) {
    var any = form.querySelector('[name="' + name + '"]');
    var group = any && any.closest('.tc-chips');
    var lab = group && group.querySelector('[data-na-label="1"]');
    if (lab) lab.parentNode.removeChild(lab);
  }

  function toggle(name, hide) {
    var f = fieldOf(name);
    if (f) f.style.display = hide ? 'none' : '';
  }

  function applyPosition() {
    if (!posEl) return;
    var front = posEl.value === FRONT_DESK;

    toggle('years', front);
    toggle('clientele', front);
    toggle('clientsPerMonth', front);
    toggle('specialties', front);

    if (yearsEl) {
      if (front) {
        if (yearsEl.value !== NA) prev.years = yearsEl.value;
        addNaOption(yearsEl);
        yearsEl.value = NA;
      } else {
        // Removing the selected option collapses the select to index 0, so the
        // sentinel has to be detected BEFORE the option is dropped. Otherwise a
        // stylist changing position would have their own answer wiped.
        var wasNa = yearsEl.value === NA;
        dropNaOption(yearsEl);
        if (wasNa) yearsEl.value = prev.years || '';
      }
    }

    if (front) {
      var cr = addNaRadio('clientele');
      if (cr) cr.checked = true;
    } else {
      dropNaRadio('clientele');
    }

    if (clientsEl) {
      if (front) {
        if (clientsEl.value) prev.clients = clientsEl.value;
        clientsEl.value = '';
      } else if (prev.clients) {
        if (!clientsEl.value) clientsEl.value = prev.clients;
        prev.clients = '';
      }
    }

    var boxes = specBoxes();
    if (front) {
      if (prev.specs === null) {
        prev.specs = [].filter.call(boxes, function (c) { return c.checked; })
                       .map(function (c) { return c.value; });
      }
      [].forEach.call(boxes, function (c) { c.checked = false; });
    } else if (prev.specs !== null) {
      var saved = prev.specs;
      [].forEach.call(boxes, function (c) { c.checked = saved.indexOf(c.value) > -1; });
      prev.specs = null;
    }

    if (extEl) {
      if (front) {
        if (extEl.value) prev.ext = extEl.value;
        extEl.value = '';
      } else if (prev.ext) {
        if (!extEl.value) extEl.value = prev.ext;
        prev.ext = '';
      }
    }

    // Front desk hides it outright; otherwise defer to the Extensions checkbox,
    // which is what thl-careers.js does on its own change handler.
    if (extWrap) {
      extWrap.hidden = front || !form.querySelector('input[name="specialties"][value="Extensions"]:checked');
    }

    if (front) {
      setErr('years', '');
      setErr('clientele', '');
    }
  }

  form.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'position') applyPosition();
  });
  applyPosition();
  // Deferred scripts already run after thl-careers.js restore(), so this is only
  // for the browser's own form restoration on reload or back-navigation, which
  // repopulates selects late and fires no change event.
  setTimeout(applyPosition, 400);
})();
